export default class GlobalFunctions {
  whiteSpaceValidation(str: any) {
    if (!str.trim().length) {
      return null;
    } else {
      return str.trimStart();
    }
  }
}
